export default __webpack_public_path__ + "static/media/map-2.4a3ef7e9.svg";